/* eslint-disable no-undef */
import Promise from 'promise-polyfill';
import VueI18n from '@/translations/';
import CookieManager from '../../../centiva-assets/frontend/utils/CookieManager';

const actions = {
	LOGIN(context, data) {
		const email = data.email.toLowerCase();

		return Centios.post('SSO_LOGIN', {
			username: email,
			password: data.password,
		});
	},

	UPDATE_TOKEN(context, data) {
		return new Promise((resolve, reject) => {
			try {
				const cookieManager = new CookieManager();
				cookieManager.set(data.name, data.value);
				resolve();
			} catch (error) {
				reject(error);
			}
		});
	},

	SAVE_TOKENS(context, data) {
		return new Promise((resolve, reject) => {
			try {
				const cookieManager = new CookieManager();
				cookieManager.set('cat', data.access_token, '30d');
				cookieManager.set('crt', data.refresh_token, '30d');
				cookieManager.set('cit', data.id_token, '30d');
				cookieManager.set('lang', VueI18n.locale, '30d');
				resolve();
			} catch (error) {
				reject(error);
			}
		});
	},

	RESET_PASSWORD(context, data) {
		const email = data.email.toLowerCase();

		return Centios.post('SSO_RESET_PASSWORD', {
			username: email,
			password: data.newPassword,
			token: data.resetToken,
		});
	},

	SEND_FORGOT_PASSWORD_EMAIL(context, data) {
		const email = data.email.toLowerCase();

		return Centios.post('SSO_REQUEST_CODE', {
			email,
		});
	},

	LOGOUT() {
		return new Promise((resolve, reject) => {
			try {
				const cookieManager = new CookieManager();
				cookieManager.remove('cat');
				cookieManager.remove('crt');
				cookieManager.remove('cit');
				cookieManager.remove('lang');
				cookieManager.remove('instance');
				cookieManager.remove('personification');
				resolve();
			} catch (error) {
				reject(error);
			}
		});
	},

	INVALIDATE_TOKENS() {
		return new Promise((resolve, reject) => {
			try {
				const cookieManager = new CookieManager();
				cookieManager.remove('cat');
				cookieManager.remove('crt');
				cookieManager.remove('cit');
				cookieManager.remove('lang');
				cookieManager.remove('instance');
				cookieManager.remove('personification');
				resolve();
			} catch (error) {
				reject(error);
			}
		});
	},

	VALIDATE_TOKENS(context, data) {
		return Centios.post('SSO_VALIDATE_TOKENS', {
			access_token: data.accessToken,
			refresh_token: data.refreshToken,
			refresh: data.refresh,
		});
	},

	VALIDATE_RESET_TOKEN(context, resetToken) {
		return Centios.post('SSO_VALIDATE_RESET_TOKEN', {
			reset_password_token: resetToken,
		});
	},
};

export default ({
	namespaced: true,
	actions,
});
